/* eslint-disable react/jsx-key */
import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import * as moment from 'moment';
import classNames from 'classnames';
import { BuscarAtrasados } from '../../services/contratos';
import { ProgressSpinner } from 'primereact/progressspinner';
import './style.css';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import { rowClass } from './rowClass';

import { mascaraCpf } from '../../modulos/mascaraCpf/index';
import { mascaraTelefone } from '../../modulos/mascaraTelefone';

export class ContratosAtraso extends Component {
    constructor() {
        super();
        this.state = {
            cod: decriptoLocalStorage('codigo_vendedor')?.decriptoValue,
            selectedRegistros: null,
            selectedStatus: null,
            submit: false,
            loading: 'loading'
        };
        this.statuses = ['Ativo', 'Suspenso'];
    }

    componentDidMount() {
        this.setState({ loading: 'nada',
            submit: true });
        this.setState({ cod: decriptoLocalStorage('codigo_vendedor')?.decriptoValue });

        BuscarAtrasados(this.state.cod)
            .then(response => {
                if (response.length > 0) {
                    for (let i = 0; i < response.length; i++) {
                        response[i].Data = moment(response[i].Data)
                            .add(3, 'hours')
                            .format('DD-MM-YYYY');

                        switch (response[i].Status) {
                        case 1:

                            response[i].Status = 'Ativo';
                            break;
                        case 2:
                            response[i].Status = 'Suspenso';
                            break;
                        case 3:
                            response[i].Status = 'Cancelado';
                            break;

                        default:
                            response[i].Status = 'Cancelado';
                            break;
                        }

                        switch (response[i]['AssTipoCobranca']) {
                        case 1:
                            response[i]['AssTipoCobranca'] = 'Boleto';
                            break;

                        default:
                            response[i]['AssTipoCobranca'] = 'Cartão de Credito Recorrente';
                            break;
                        }
                    }

                    this.setState({ contratos: response });
                    this.setState({ loading: 'loading',
                        submit: false });
                } else {
                    this.setState({ loading: 'loading',
                        submit: false });
                }
            })
            .catch(erro => {
                this.setState({ loading: 'loading',
                    submit: true });
            });
    }

    statusBodyTemplate = rowData => (
        <React.Fragment>
            <span className="p-column-title" >Status</span>
            {rowData.Status}
        </React.Fragment>
    );

    statusItemTemplate = option => (
        <span className={classNames('customer-badge', `Status-${  option}`)}>
            {option}
        </span>
    );

    onStatusFilterChange = event => {
        this.dt.filter(event.value, 'Status', 'equals');
        this.setState({ selectedStatus: event.value });
    };

    renderStatusFilter() {
        return (
            <Dropdown
                value={this.state.selectedStatus}
                options={this.statuses}
                onChange={this.onStatusFilterChange}
                itemTemplate={this.statusItemTemplate}
                showClear={true}
                placeholder="Select a Status"
                className="p-column-filter"
            />
        );
    }

    renderHeader() {
        return (
            <div
                className="p-grid p-fluid"
                style={{ background: '#F4C27A',
                    alignItems: 'left' }}
            >
                <div className="p-col-6 p-md-6">
                    <InputText
                        type="search"
                        onInput={e =>
                            this.setState({ globalFilter: e.target.value })
                        }
                        placeholder="Buscar por termo, ex: nº da Inscrição"
                    />
                </div>
                <div className="p-col-6 p-md-6"></div>
            </div>
        );
    }

    inscricaoBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <span className="p-column-title">Inscrição</span>
                {rowData.Inscricao}
            </React.Fragment>
        );
    }

    nomeBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <span className="p-column-title">Nome</span>
                {rowData.Nome}
            </React.Fragment>
        );
    }

    dataBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <span className="p-column-title">Data Venda</span>
                {moment(rowData.Data, ['DD-MM-YYYY'])
                    .add(3, 'hours')
                    .format('DD/MM/YYYY')}
            </React.Fragment>
        );
    }

    vencimentoBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <div className='coluna'>
                    <span className="p-column-title">Vencimento</span>
                    <div className="conteudo-coluna">
                        {rowData.Vencimento.map(e => (
                            <span>{moment(e).add(3, 'hours').format('DD/MM/YYYY')}</span>
                        ))}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    valorBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <div className='coluna'>
                    <span className="p-column-title">Valor</span>
                    <div className="conteudo-coluna">
                        {rowData.Valor.map(e => (
                            <span>
                                {new Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                }).format(e)}
                            </span>
                        ))}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    cpfBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <span className="p-column-title">CPF</span>
                {mascaraCpf(rowData.Cpf)}
            </React.Fragment>
        );
    }

    telefoneBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <div className='coluna'>
                    <span className="p-column-title">Telefone</span>
                    <div className="conteudo-coluna">
                        <p>
                            {rowData.Telefone === rowData.Celular && mascaraTelefone(rowData.Telefone)}
                        </p>

                        <p>
                            {rowData.Telefone !== rowData.Celular && mascaraTelefone(rowData.Telefone)}
                        </p>
                        <p>{rowData.Telefone !== rowData.Celular && mascaraTelefone(rowData.Celular)}</p>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    valorTotalBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <span className="p-column-title">Valor Total</span>
                {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(rowData.ValorTotal)}
            </React.Fragment>
        );
    }

    assTipoCobrancaBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <span className="p-column-title">Tipo Cobrança</span>
                {rowData.AssTipoCobranca}
            </React.Fragment>
        );
    }

    render() {
        const header = this.renderHeader();
        const statusFilter = this.renderStatusFilter();

        return (
            <div>
                <div className={this.state.loading}>
                    <ProgressSpinner
                        style={{
                            width: '300px',
                            height: '150px',
                            display: 'flex',
                            margin: '0 auto',
                            marginTop: '8%'
                        }}
                        strokeWidth="1"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                    />
                </div>
                {this.state.submit !== true ? (
                    <div className="datatable-responsive-demo">
                        <div className="card">
                            <DataTable
                                value={this.state.contratos}
                                header={header}
                                ref={el => (this.dt = el)}
                                dataKey="id"
                                globalFilter={this.state.globalFilter}
                                selection={this.state.selectedRegistros}
                                onSelectionChange={e =>
                                    this.setState({
                                        selectedRegistros: e.value
                                    })
                                }
                                paginator
                                rows={8}
                                emptyMessage="Nenhum resultado encontrado"
                                currentPageReportTemplate="Mostrando {first} de {last} em {totalRecords}  Registros encontrados"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                rowsPerPageOptions={[8, 25, 50]}
                                className="p-datatable-responsive-demo"
                                rowClassName={rowClass}
                            >
                                <Column
                                    field="Inscricao"
                                    header="Inscrição"
                                    body={this.inscricaoBodyTemplate}
                                    className="Inscricao"

                                ></Column>
                                <Column
                                    field="Nome"
                                    header="Nome"
                                    body={this.nomeBodyTemplate}
                                    className="Nome"

                                ></Column>
                                <Column
                                    field="Data"
                                    header="Data Venda"
                                    className="Data-Venda"
                                    body={this.dataBodyTemplate}
                                ></Column>
                                <Column
                                    field="Vencimento"
                                    header="Vencimento"
                                    className="Vencimento"
                                    body={this.vencimentoBodyTemplate}
                                ></Column>
                                <Column
                                    field="Valor"
                                    header="Valor"
                                    body={this.valorBodyTemplate}
                                    className="Valor"
                                ></Column>
                                <Column
                                    field="Total"
                                    header="Total"
                                    body={this.valorTotalBodyTemplate}
                                    className="Total"

                                ></Column>
                                <Column
                                    field="Cpf"
                                    header="CPF"
                                    body={this.cpfBodyTemplate}
                                    className="CPF"
                                ></Column>
                                <Column
                                    field="Telefone"
                                    header="Telefone(s)"
                                    body={this.telefoneBodyTemplate}
                                    className="Telefone"
                                ></Column>
                                <Column
                                    field="AssTipoCobranca"
                                    header="Tipo Cobrança"
                                    body={this.assTipoCobrancaBodyTemplate}
                                    className="AssTipoCobranca"
                                ></Column>
                                <Column
                                    field="Status"
                                    header="Status"
                                    body={this.statusBodyTemplate}
                                    sortable
                                    filter
                                    filterElement={statusFilter}
                                    className="Status"
                                />
                            </DataTable>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default ContratosAtraso;
